import { TagCloseIcon } from '@fiverr-private/data_display';

export default TagCloseIcon;
